module.exports = __webpack_public_path__ + "static/media/settings.4f4819c8.png";